import { render, staticRenderFns } from "./ExpertFeesSTable.vue?vue&type=template&id=3da139d1"
import script from "./ExpertFeesSTable.vue?vue&type=script&lang=js"
export * from "./ExpertFeesSTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports